import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import TvStage, { shouldUseTvStage } from './TvStage';
import { AuthProvider } from './auth';
import './styles.css';
import './calendar-fix.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    {shouldUseTvStage() ? <TvStage /> : <AuthProvider><App /></AuthProvider>}
  </React.StrictMode>,
);
